// extracted by mini-css-extract-plugin
module.exports = {"loader":"App_loader_2Gbcq"};